<input #fileInput type="file" id="fileInput" class="form-control d-none" (change)="onFileSelected($event)" accept=".pdf" multiple />

<ng-template #modalLG let-modal>
    <div class="modal-header" style="background-color: transparent; border-bottom: none;">
        <button type="button" class="close" (click)="modal.dismiss('Cross click')" aria-label="Close">
            <span aria-hidden="true">&times;</span>
        </button>
    </div>
    <div class="modal-body d-flex flex-column align-items-center justify-content-center text-center" style="padding: 30px 64px 64px 64px;">
        <p style="font-size: 20px; font-weight: 600; color: #2F2B3D;" class="m-0">Pièce jointe</p>
        <p style="font-size: 14px; font-weight: 400; color: #6B7280;" class="m-0">
            Ajoutez une pièce jointe depuis votre appareil.
        </p>

        <div class="step-form d-flex flex-column align-items-center justify-content-center text-center w-100">
            <div
                    class="form-section rounded border-style"
                    (click)="triggerFileInput($event)"
                    (dragover)="onDragOver($event)"
                    (drop)="onDrop($event)"
                    style="text-align: center; cursor: pointer; padding: 24px;"
                    [ngClass]="{
          'default-bg': selectedFiles.length === 0,
          'success-bg': selectedFiles.length > 0
        }"
            >
                <!-- Icône avant upload -->
                <a *ngIf="selectedFiles.length === 0" class="action-icon" style="margin-bottom: 16px;">
                    <i class="bi bi-file-earmark-check" style="color: rgba(19, 74, 211, 1); font-size: 25px;"></i>
                </a>

                <!-- Icône après upload -->
                <a *ngIf="selectedFiles.length > 0" class="action-icon" style="margin-bottom: 16px;">
                    <i class="bi bi-file-earmark-check" style="color: #28C76F; font-size: 25px;"></i>
                </a>

                <!-- Display list of selected files -->
                <div *ngIf="selectedFiles.length > 0" class="file-list" style="font-size: 16px; font-weight: 500; color: #2F2B3D; max-height: 150px; overflow-y: auto; width: 100%;">
                    <div *ngFor="let file of selectedFiles" class="file-name">
                        {{ file.name }}
                        <span *ngIf="pieceJointe.taille" style="font-size: 12px; color: #6B7280;"> ({{ file.size | number:'1.0-2' }} bytes)</span>
                        <span *ngIf="pieceJointe.derniereMiseAJour" style="font-size: 12px; color: #6B7280;"> ({{ file.lastModified | date:'short' }})</span>
                    </div>
                </div>

                <p *ngIf="selectedFiles.length === 0" style="font-size: 14px; font-weight: 500; color: #2F2B3D; margin: 0;">
                    Déposez les fichiers ici ou cliquez pour télécharger
                </p>
                <p *ngIf="selectedFiles.length > 0" style="font-size: 14px; font-weight: 500; color: #28C76F; margin: 0;">
                    Importation prête !
                </p>
                <p *ngIf="selectedFiles.length === 0" style="font-size: 12px; font-weight: 400; color: #6B7280; margin-top: 8px;">
                    Télécharger jusqu'à 10 fichiers (PDF, max 1 Mo chacun)
                </p>

                <a *ngIf="selectedFiles.length === 0" class="action-icon" style="color: rgba(19, 74, 211, 1); margin-top: 16px;">
                    <span data-feather="download" [size]="23"></span>
                </a>
                <br>
                <a *ngIf="selectedFiles.length > 0" class="action-icon" style="color: #28C76F;">
                    <span data-feather="check-circle" [size]="23"></span>
                </a>
            </div>
        </div>

        <div class="form-group" style="margin-top: 16px; width: 100%;">
            <div class="checkbox-group" style="display: flex; flex-direction: row; align-items: center; justify-content: center; gap: 16px;">
                <label class="checkbox-item d-flex align-items-center" style="font-size: 14px; color: #2F2B3D;">
                    <input type="checkbox" [(ngModel)]="pieceJointe.nom">
                    <span style="margin-left: 8px;">Nom</span>
                </label>
                <label class="checkbox-item d-flex align-items-center" style="font-size: 14px; color: #2F2B3D;">
                    <input type="checkbox" [(ngModel)]="pieceJointe.taille">
                    <span style="margin-left: 8px;">Taille</span>
                </label>
                <label class="checkbox-item d-flex align-items-center" style="font-size: 14px; color: #2F2B3D;">
                    <input type="checkbox" [(ngModel)]="pieceJointe.derniereMiseAJour">
                    <span style="margin-left: 8px;">Dernière mise à jour</span>
                </label>
            </div>
        </div>

        <div class="modal-footer p-0" style="justify-content: center; gap: 16px; border-top: none;">
            <button
                    type="button"
                    class="btn d-flex align-items-center justify-content-center"
                    style="padding: 8px 16px; font-size: 14px; background-color: rgba(128, 131, 144, 0.16);"
                    (click)="modal.dismiss('Cancel click')"
            >
                Annuler
            </button>
            <button
                    type="button"
                    class="btn btn-primary d-flex align-items-center justify-content-center"
                    style="padding: 8px 16px; font-size: 14px;"
                    [disabled]="selectedFiles.length === 0"
                    (click)="importFile()"
            >
                Importer
            </button>
        </div>
    </div>
</ng-template>
